import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Button, Col, Modal, Row, Table } from 'react-bootstrap';
import { userStore } from 'store/UserStore';
import RedeemGiftModal from './RedeemGiftModal';
import giftHttp from './services/gift.service';
import { Pagination } from 'shared/common/pagination';
import Loader from 'shared/common/loader';
import './style.css';

interface PropsType {
  getPassbookSummary?: any;
}

const metalMapping = {
  "Au": "Gold",
  "Ag": "Silver",
  "Pt": "Platinum",
  "Pd": "Palladium"

}

const ReceivedGifts: React.FC<PropsType> = ({ getPassbookSummary }) => {
  const [loading, setLoading] = useState<any>(false);
  const [customerId, setUser, user, userData, setCustomer, customer] =
    userStore((state: any) => [
      state.customerId,
      state.setUser,
      state.user,
      state.userData,
      state.setCustomer,
      state.customer,
    ]);
  const [open, setOpen] = useState<any>(false);
  const [isAcceptGift, setIsAcceptGift] = useState<any>(false);
  const [orderRef, setOrderRef] = useState<any>('');
  const [giftsList, setGiftsList] = useState<any>([]);
  const [metaData, setMetaData] = useState<any>({});
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [senderCustId, setSenderCustId] = useState<number>(0);
  const [selectedMessage, setSelectedMessage] = useState<string | null>(null);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState<boolean>(false);


  const handleShowMessage = (message: string) => {
    setSelectedMessage(message);
    setIsMessageModalOpen(true);
  };

  const handleCloseMessage = () => {
    setIsMessageModalOpen(false);
    setSelectedMessage('');
  };

  const getMetalName = (code) => {
    return metalMapping[code] || "Unknown Metal";
  };


  const rejectModalOpen = (orderRefId, senderId) => {
    setOpen(true);
    setOrderRef(orderRefId);
    setSenderCustId(senderId);
  };

  const onCancel = () => {
    setOpen(false);
  };

  const receivedGiftsList = async (page) => {
    try {
      const number = customer?.kyc?.mobile?.value.split('+');
      const res = await giftHttp.receievedGiftsList(
        number[1],
        customer?.partner?.id,
        page
      );
      if (res?.status == 200) {
        setGiftsList(res?.data?.data?.result);
        setCurrentPage(page);
        setMetaData({
          current: res.data.meta.page,
          pages: res.data.meta.totalPages + 1,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  const rejectGiftFunc = async () => {
    try {
      const payload = {
        ebOrderRefs: orderRef,
        gift: 'true',
        sendersId: senderCustId,
      };
      const res = await giftHttp.rejectGift(payload);
      if (res?.status == 200) {
        toast.success('Gift Rejected successfully!');

        receivedGiftsList(0);
        setOpen(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const acceptGiftFunc = async (giftId) => {
    try {
      setIsAcceptGift(true);
      setLoading(true);
      const payload = {
        giftId: giftId,
        partnerId: customer?.partner?.id,
      };
      const res = await giftHttp.acceptGift(payload);

      if (res?.status) {
        toast.success('Gift Accepted Successfully');
        receivedGiftsList(0);
        getPassbookSummary();
        setIsAcceptGift(false);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      toast.error('Something went wrong');
      setIsAcceptGift(false);
      setLoading(false);
    }
  };


  useEffect(() => {
    receivedGiftsList(0);
  }, []);



  return (
    <>
      {loading && <Loader />}
      <div className='t-wrap overflow-auto'>
        <Table className='mb-0 w-100 txn__table' striped hover responsive>
          <thead>
            <tr>
              {/* <th>Id</th> */}
              <th>From</th>
              {/* <th>Mobile</th> */}
              <th>Metal</th>
              <th>Quantity</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {giftsList[0] ? (
              giftsList?.map((gift, index) => (
                <tr key={index}>
                  <td>{gift?.displayName}</td>
                  <td>{getMetalName(gift?.metal)}</td>
                  <td>{gift?.metalQuantity}g</td>
                  <td> <div
                    className={`badge ${gift?.status == 'ACCEPTED'
                      ? 'bg-success'
                      : 'bg-secondary'
                      }`}
                  >
                    {gift?.status}
                  </div></td>


                  <td>
                    <div className="button-container">
                      {gift?.status === 'ACTIVE' && (
                        <>
                          <Button
                            variant='primary'
                            bsPrefix='btn-table'
                            onClick={() => acceptGiftFunc(gift?.id)}
                            disabled={isAcceptGift}
                          >
                            Accept
                          </Button>
                          <Button
                            variant='primary'
                            bsPrefix='btn-table'
                            onClick={() =>
                              rejectModalOpen(gift?.ebOrderRef, gift?.customerId)
                            }
                          >
                            Reject
                          </Button>
                        </>
                      )}

                      {gift?.message.length > 0 && (
                        <Button
                          bsPrefix='btn-table'
                          className='view-btn'
                          onClick={() => handleShowMessage(gift?.message)}
                        >
                          View Message
                        </Button>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5}>
                  <div className='m-2 d-flex justify-content-center'>
                    No data to display
                  </div>
                </td>
              </tr>
            )}

            {/* )} */}
          </tbody>
        </Table>
        <Modal show={isMessageModalOpen} onHide={handleCloseMessage} centered>
          <Modal.Header closeButton>
            <Modal.Title> 🎁  A special note just for you! </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{selectedMessage}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={handleCloseMessage}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <RedeemGiftModal
          showModal={open}
          closeModal={setOpen}
          proceed={rejectGiftFunc}
          cancel={onCancel}
          text={'Are you sure, you want to reject gift.'}
          okButton={'Proceed'}
          cancelButton={'Cancel'}
        />
      </div>
      <Row>
        <Col md={12}>
          {/* Pagination Bar */}
          {!loading && metaData.pages > 1 && (
            <Pagination
              meta={metaData}
              handlePageChange={(number: number) => receivedGiftsList(number)}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default ReceivedGifts;
